import { ThemeProvider } from "@emotion/react";
import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import FileListComponent from "./component/filelist/filelist.component";
import UploadComponent from "./component/upload/upload.component";
import { customTheme } from "./themes";

const CustomRouter = () => {
    return <ThemeProvider theme={customTheme}>
        <HashRouter>
            <App />
            <Routes>
                <Route path="/" element={<UploadComponent />} />
                <Route path="/files" element={<FileListComponent />} />
            </Routes>
        </HashRouter>
    </ThemeProvider>
}

export default CustomRouter;